// ============================================
// Author						: Prabakaran
// Description			:
// Date							:
// ============================================
import { Component, OnInit, AfterViewInit, ChangeDetectionStrategy, NgZone, ChangeDetectorRef } from '@angular/core';
import { UtilitesService } from '@systemic/services';
import { TreeNode } from 'primeng/api';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { MlUser, MlCompany } from '@systemic/interface';
import { MlBranch } from '@service/auth/auth.modal';
declare let mLayout: any;
@Component({
  selector: 'nav-aside',
  templateUrl: './nav-aside.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavasideComponent implements OnInit, AfterViewInit {
  public lstMenu: TreeNode[];
  public userInfo: MlUser;
  public branchInfo: MlBranch;
  public companyInfo: MlCompany;
  constructor(public lib: UtilitesService, private zone: NgZone,
    private cd: ChangeDetectorRef) {
    this.userInfo = lib.TokenContext.UserInfo;
    this.branchInfo = lib.TokenContext.BranchInfo;
    this.companyInfo = lib.TokenContext.CompanyInfo;
  }

  ngOnInit() {
    this.getMenuList();
  }
  ngAfterViewInit() {
    this.zone.runOutsideAngular(() => {
      mLayout.initAside();
    });
  }
  getMenuList() {
    this.lib.http
      .get<TreeNode[]>(
        `web/user/role/menu-list/${this.userInfo.RoleSysID}`
      )
      .subscribe(
        res => {
          if (this.lib.isValidList(res.result)) {
            this.lstMenu = [];
            this.lstMenu = res.result;
            this.lstMenu = this.lstMenu.slice();
            this.cd.markForCheck();
          }
        },
        (e: ErrorObservable) => {
          if (e.error) {
            this.lib.notify.error(e.error.message);
          }
        }
      );
  }
}



// WEBPACK FOOTER //
// E:/GangaJewallery-Final/app.server/systemic.app.server/client/src/main/app/@layout/nav-aside/nav-aside.component.ts